import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { Observable } from 'rxjs';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../services/media-query.service';
import { FocusTrapper, FocusTrapperFactory } from '../../components/focus/focus-trapper-factory';
import { ButtonComponent } from '../../components/button/button.component';
import { IconComponent } from '../../components/icon/icon.component';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'td-wb-filter-window',
  templateUrl: 'filter-window.component.html',
  styleUrls: ['filter-window.component.scss'],
  imports: [
    ButtonComponent,
    TranslatePipe,
    IconComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterWindowComponent implements OnInit, OnChanges {
  @Input() filtersOpened: boolean;
  @Output('close') readonly closeEvent: EventEmitter<void> = new EventEmitter<void>();

  breakpointChanges$: Observable<BreakpointState>;
  private focusTrapper: FocusTrapper;

  constructor(private readonly elementRef: ElementRef,
              private readonly mediaQueryService: MediaQueryService,
              private readonly focusTrapperFactory: FocusTrapperFactory) {
    this.focusTrapper = this.focusTrapperFactory.create(this.elementRef.nativeElement,
      { autoFocus: true });
  }

  ngOnInit(): void {
    this.breakpointChanges$ = this.mediaQueryService.observe(Breakpoint.SM);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filtersOpened !== undefined) {
      if (changes.filtersOpened.currentValue === true) {
        this.focusTrapper.savePreviouslyFocusedElement();
        this.focusTrapper.autoFocusFirstTabbableElement();
      } else {
        this.focusTrapper.returnFocusAfterClose();
        this.focusTrapper.destroy();
      }
    }
  }

  close(): void {
    this.closeEvent.emit();
  }
}
